import { cn } from '@eliadmin/core/src/utils/style-utils';

type TCustomHeading = {
  subtitle?: string;
  title: string;
  headingTag?: 'h1' | 'h2';
  underline?: {
    full?: boolean;
    lastWord?: boolean;
    firstWord?: boolean;
    className?: string;
  };
  children?: React.ReactNode;
};

export const CustomHeading = ({
  subtitle,
  title,
  underline,
  children,
  headingTag = 'h2',
}: TCustomHeading) => {
  const Title = headingTag;
  return (
    <div className={cn('', 'ea-custom-heading__box')}>
      {subtitle && (
        <p data-ea-visual-tag="h2" className={cn('', 'ea-custom-heading__subtitle')}>
          {subtitle}
        </p>
      )}
      <Title data-ea-visual-tag="h1" className={cn('', 'ea-custom-heading__title')}>
        {title}
      </Title>
      {children}
    </div>
  );
};
